/**
 * Formata telefone brasileiro para padrão internacional
 * Regra: 55 + DDD + número
 * Se DDD >= 30 e número começa com 9, remove o 9
 * 
 * Exemplos:
 * (31)98529-4340 → 5531985294340 (DDD 31 >= 30, remove 9)
 * (21)98529-4340 → 5521985294340 (DDD 21 < 30, mantém 9)
 * (11)3456-7890 → 55113456789 (fixo, sem 9)
 * (35)91234-5678 → 553512345678 (DDD 35 >= 30, remove 9)
 */
export const formatPhoneForBrazil = (input) => {
    if (!input) return "";

    // Remove tudo exceto números
    const numbers = input.replace(/\D/g, '');

    // Precisa ter pelo menos DDD + número (mínimo 10 dígitos)
    if (numbers.length < 10) {
        return numbers; // Retorna como está se incompleto
    }

    // Extrair DDD (primeiros 2 dígitos)
    const ddd = parseInt(numbers.substring(0, 2));

    // Extrair restante do número
    let phoneNumber = numbers.substring(2);

    // Se DDD >= 30 e número começa com 9 e tem 9 dígitos, remover o 9
    if (ddd >= 30 && phoneNumber.charAt(0) === '9' && phoneNumber.length === 9) {
        phoneNumber = phoneNumber.substring(1);
    }

    // Retornar com código do país
    return `55${ddd}${phoneNumber}`;
};

/**
 * Formata telefone para exibição visual
 * (XX) XXXXX-XXXX ou (XX) XXXX-XXXX
 */
export const formatPhoneDisplay = (phone) => {
    if (!phone) return "";

    const numbers = phone.replace(/\D/g, '');

    if (numbers.length === 11) {
        return `(${numbers.substring(0, 2)}) ${numbers.substring(2, 7)}-${numbers.substring(7)}`;
    } else if (numbers.length === 10) {
        return `(${numbers.substring(0, 2)}) ${numbers.substring(2, 6)}-${numbers.substring(6)}`;
    }

    return phone;
};

/**
 * Valida se o telefone está completo
 */
export const isValidPhone = (phone) => {
    const numbers = phone.replace(/\D/g, '');
    return numbers.length >= 10 && numbers.length <= 11;
};
